
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lCHNh", function(module, exports) {
/* TeammateContentRecommendationBanner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $l3wuH = parcelRequire("l3wuH");


var $1sCHt = parcelRequire("1sCHt");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");

var $b2a14cfde8379958$exports = {};
$b2a14cfde8379958$exports = new URL("LightWelcomeImage.b703b601.png", import.meta.url).toString();


var $89575359752818bd$exports = {};
$89575359752818bd$exports = new URL("DarkWelcomeImage.ebbc9b04.png", import.meta.url).toString();


const $a582536f0b887dff$var$useContentRecommendationParam = (0, $dPJCf.createSingleQueryParamHook)('contentRecommendation');
const $a582536f0b887dff$var$usePopularParam = (0, $dPJCf.createSingleQueryParamHook)('popular');
const $a582536f0b887dff$var$unboundedStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL4p0Oa _2bqfgdOeNX _1x1D3gOeNX _39xV02j8JR _2XsHFM5ksT _0KLXruVva3 _0jFU0VymWf _1mT5xdRAKS",
    headingStyles: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _3iDTPbgJ9S _4Gn54R7dHp _1U1ZhbbI28",
    subtextStyles: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28",
    livePageStyle: "_2bqfgdYbGa _2XsHFMPgdg _39xV02IZbP"
};
const $a582536f0b887dff$var$styles = {
    contentContainerStyles: "_2mHwu82ADO _4FKVYENHnM _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _42Yu6B7dHp _39xV02ygnw",
    svgContainer: "_39xV02iLlu _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa",
    closeButton: "_1mT5xdWVPG _2IhTon8HPE _4ApkO28HPE _1pp6NdIZbP"
};
const $a582536f0b887dff$var$i18n = (0, $kSwu1.defineMessages)({
    bannerWelcomeMessage: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.heading",
        defaultMessage: "Welcome to Confluence"
    },
    bannerWelcomeMessageWithName: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.heading.with-name",
        defaultMessage: "Welcome to Confluence, {firstName}"
    },
    bannerDefaultSubtext: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.no.teammates.subtext",
        defaultMessage: "This page was handpicked for you based on your role to help you dive into what\u2019s most relevant as you start in Confluence."
    },
    bannerTeammatesSubtext: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.with.teammates.subtext",
        defaultMessage: "This page was handpicked for you based on your role and teammates to help you dive into what\u2019s most relevant as you start in Confluence."
    },
    bannerDismissLabel: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.dismiss",
        defaultMessage: "Dismiss banner"
    },
    bannerPopularSubtext: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.with.popular.subtext",
        defaultMessage: "We\u2019ve handpicked this page from your organization\u2019s most popular content so you can dive into what people find most useful."
    }
});
const $a582536f0b887dff$var$TeammateContentRecommendationBannerContent = ({ isLivePage: isLivePage })=>{
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const popularParam = $a582536f0b887dff$var$usePopularParam();
    const isPopularMessageVariant = popularParam === 'true';
    const firstName = displayName?.split(' ')[0] ?? null;
    (0, $cozmU.useEffect)(()=>{
        if (!isDismissed) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'teammateContentRecommendationBanner'
            }
        }).fire();
    }, [
        isDismissed,
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        setIsDismissed(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'teammateContentRecommendationBanner',
                source: 'viewPageContentContainer'
            }
        }).fire();
        setQueryParams({
            contentRecommendation: undefined
        });
    };
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "teammate-content-recommendation-banner",
        className: (0, $hekY6.default)([
            $a582536f0b887dff$var$unboundedStyles.root,
            isLivePage && $a582536f0b887dff$var$unboundedStyles.livePageStyle
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a582536f0b887dff$var$styles.contentContainerStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a582536f0b887dff$var$unboundedStyles.headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, firstName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a582536f0b887dff$var$i18n.bannerWelcomeMessageWithName,
        values: {
            firstName: firstName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a582536f0b887dff$var$i18n.bannerWelcomeMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a582536f0b887dff$var$unboundedStyles.subtextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, isPopularMessageVariant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a582536f0b887dff$var$i18n.bannerPopularSubtext) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a582536f0b887dff$var$i18n.bannerTeammatesSubtext)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a582536f0b887dff$var$styles.svgContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b2a14cfde8379958$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($89575359752818bd$exports))),
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a582536f0b887dff$var$styles.closeButton)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "teammate-content-button-close",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: $a582536f0b887dff$var$i18n.bannerDismissLabel.defaultMessage,
        onClick: handleDismiss
    })));
};
const $a582536f0b887dff$var$TeammateContentRecommendationBannerInner = ({ contentId: contentId, isLivePage: isLivePage })=>{
    const contentRecommendationParam = $a582536f0b887dff$var$useContentRecommendationParam();
    const isValidBannerRoute = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
    const shouldRenderBanner = isValidBannerRoute && !!contentId && contentRecommendationParam === 'on' && (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate');
    if (!shouldRenderBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a582536f0b887dff$var$TeammateContentRecommendationBannerContent, {
        isLivePage: isLivePage
    });
};
const $a582536f0b887dff$export$f9de7c50725ea941 = ({ contentId: contentId, isLivePage: isLivePage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a582536f0b887dff$var$TeammateContentRecommendationBannerInner, {
        contentId: contentId,
        isLivePage: isLivePage
    }));
};
module.exports["TeammateContentRecommendationBanner"] = $a582536f0b887dff$export$f9de7c50725ea941;

});


//# sourceMappingURL=TeammateContentRecommendationBanner.a6b3c50f.js.map
